import FormEditAndAddControl from "../../../../components/BuilderComponents/FormEditAndAddControl";
import MaterialIcon from "../../../../components/BuilderComponents/MaterialIcon";
import { getFieldIcon } from "../../../../utils/getFieldIcon";
import FieldTag from "../../../Form/FieldTags/FieldTag";
import React from "react";
import { useStatemachineContext } from "../../../../context/StatemachineContext";
import { useParams } from "react-router-dom";

const ActivityForm = ({ activityForm }) => {
  const { selectedStateMachine } = useStatemachineContext();
  const { smId, activityId } = useParams();
  return (
    <div style={{ height: "calc(100vh - 150px)", overflow: "auto" }}>
      <div className="form_container">
        <div className="form_field_container form-preview" style={{ height: "auto" }}>
          <label className="tab_sub_heading">{selectedStateMachine.name}</label>
          {activityForm?.sections?.length > 0 && (
            <div className="form_field_wrapper">
              <div className="form_field_outer" style={{ marginTop: "30px" }}>
                <div className="ent_form_fields">
                  <FormEditAndAddControl
                    formIsThere={activityForm?.id ? true : false}
                    smId={smId}
                    activityId={activityId}
                  />
                </div>
                <div className="overlay_cover"></div>

                <div>
                  {activityForm?.sections?.length > 0 && (
                    <div className="stateMachine_form_container">
                      {activityForm?.sections[0]?.fields?.map((field) => {
                        const { ...fieldWithoutKey } = field;
                        return (
                          <div key={field.id} className={`single_field_render`}>
                            <MaterialIcon
                              name={getFieldIcon(field.type)}
                              style={{ color: "#667085", marginRight: "8px" }}
                            />
                            <div className="form_element_container">
                              <FieldTag key={field.id} element={fieldWithoutKey} />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ActivityForm;
